import { UUID_REGEX } from "shared/constants";
import { type Uuid } from "shared/types/index";

export function isNonNullable<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

export function isUuid(value: unknown): value is Uuid {
  if (typeof value !== "string") return false;

  return UUID_REGEX.test(value);
}
